import React from 'react';
import { Dropdown, Icon, Pagination, Popup } from 'semantic-ui-react';

const limitOptions = [
    { key: '1', value: '5', text: '5' },
    { key: '2', value: '10', text: '10' },
    { key: '3', value: '50', text: '50' },
    { key: '4', value: '100', text: '100' },
];

export const TableFooter = props => {

    let pagesOption = []
    for (let i = 1; i < props.total_Pages + 1; i++) {
        pagesOption.push(
            { key: i, value: i, text: i },
        )
    }

    function handleChange(e, item) {
        e.stopPropagation()
        let setData = {
            activePage: item.value
        }
        props.onChangePage(e, setData)
    }

    //Tooltip for pagination arrows
    function tooltip(name, content) {
        return <Popup
            trigger={<Icon name={name} />}
            content={content}
            pn="hover"
            position="top center"
            className="popupStyled"
            inverted
        />
    }

    return <React.Fragment>
        <div style={{
            display: "block",
            float: "left",
            lineHeight: "32px"
        }}>
            {/* Total Records */}
            Total Records:{' '}
            <b>{props.totalCount}</b>
            &nbsp;&nbsp;&nbsp;&nbsp;

             {/* Limit change  */}
            Records per page:{' '}
            <Dropdown
                inline
                options={limitOptions}
                defaultValue={props.limit}
                onChange={props.onChangeLimit}
            />
            {' '}  &nbsp;&nbsp;&nbsp;&nbsp;

            {/* Page change  */}
            Go to page: {' '}
            <Dropdown
                scrolling
                inline
                options={pagesOption}
                value={props.active_Page}
                onChange={handleChange}
            />
        </div>
        <div className="float-right">
            <Pagination
                totalPages={props.total_Pages}
                activePage={props.currentPage}
                onPageChange={props.onChangePage}
                style={{ float: "right" }}
                ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                firstItem={{ content: tooltip("angle double left", "First Page"), icon: true }}
                lastItem={{ content: tooltip("angle double right", "Last Page"), icon: true }}
                prevItem={{ content: tooltip("angle left", "Previous Page"), icon: true }}
                nextItem={{ content: tooltip("angle right", "Next Page"), icon: true }}
            />
        </div>
    </React.Fragment>
};
